import { useEffect } from "react";

const useTokenExpireWatcher = () => {
  let isReloadScheduled = false;
  useEffect(() => {
    const checkExpiry = () => {
      const expire = localStorage.getItem("ROCP_tokenExpire");

      if (!expire) return;

      const expireTime = Number(expire) * 1000; // convert to ms
      const now = Date.now();

      // 55 minutes before expiry
      const bufferTime = 5 * 60 * 1000;

      if (expireTime - now <= bufferTime) {
        isReloadScheduled = true;

        localStorage.setItem("ROCP_tokenExpire", 0);
        setTimeout(() => {
          window.location.reload();
        }, 60 * 1000); // reload after 1 min
      }
    };

    // run immediately
    checkExpiry();

    // run every 1 minute
    const interval = setInterval(checkExpiry, 60 * 1000);

    return () => clearInterval(interval);
  }, []);
};

export default useTokenExpireWatcher;
